<template>
    <div class="detail">
        <h2 style="text-align: center;margin-bottom: 20px;">{{title}}</h2>
        <div v-html="text"></div>
    </div>
</template>

<script>
    import {newUrl} from '@/assets/js/newurl.js'
    export default {
        name: "news-detail",
        data(){
            return{
                id:'',
                text:'',
                title:''
            }
        },
        mounted(){
            this.id=this.$route.query.id;
            this.$nextTick(()=> {
                this.getDetail();
            })
        },
        methods:{
            getDetail(){
                let that=this;
                this.$axios.get(newUrl+`/bbs/news/${this.id}`).then(function (response) {
                    if(response.data.success){
                        that.text=response.data.data.content;
                        that.title=response.data.data.title;
                    }
                }).catch(function (error) {
                    alert(error);
                });
            }
        }
    }
</script>

<style scoped>
.detail{
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/news-detail.vue